import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 28 Mar 2026 22:35 PM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.k10EcDML3j6MRu0W5xocRPLMLbUM9IzK7ajdHyor9TygF6Kil5yp15ZT82oiJzYuWtMcujTqDl3X1QvfFtmsVRjUdEcOTAZg1txJAZ7ORMztV5aiDGrxpUtayHApPP1WEHt96ls3NguDGg2tHqcqoe73xRu70SJA550L58JnBnNF9PPoFjT1zEv0BbaAlVZ8PGg7nivKHBiRyRKlqsyUmb_Hgh0ZSbl52Ur3eHQjkSOZJe7WsmsIutKaCl8ogA9G3QEAuCu54edUyWj0koUZW4CioWxuK-tJy2mWS_JqLJmNlI0l2yw_jkuFhlaPCpSO7PLUtQblbAiVME7ZHStlp3_Du3RwnXkz5g",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-05-26T15:52:01.165509Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2026-03-28T21:34:45+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.k10EcDML3j6MRu0W5xocRPLMLbUM9IzK7ajdHyor9TygF6Kil5yp15ZT82oiJzYuWtMcujTqDl3X1QvfFtmsVRjUdEcOTAZg1txJAZ7ORMztV5aiDGrxpUtayHApPP1WEHt96ls3NguDGg2tHqcqoe73xRu70SJA550L58JnBnNF9PPoFjT1zEv0BbaAlVZ8PGg7nivKHBiRyRKlqsyUmb_Hgh0ZSbl52Ur3eHQjkSOZJe7WsmsIutKaCl8ogA9G3QEAuCu54edUyWj0koUZW4CioWxuK-tJy2mWS_JqLJmNlI0l2yw_jkuFhlaPCpSO7PLUtQblbAiVME7ZHStlp3_Du3RwnXkz5g'

// {
//   "access_token": "v2.local.DAfxUTsijw_qLMveqoqq69_XgVEJpk2FNTPBkPc6-nl2tcbD-f153Rleri_E9rDYJyUJ3Kf23elLft-0TM2mw55bkw6jDX7283BeN9HjZHzvD_PqWgRsIiw5r1fuFg-LWDPl8wuWkRs5fHCVrtYtVzC4kbGuhay_Smc-IwJ6DUly3-RbObP0EYMJUD3NIbbaVM4vjvmvYH7GOYwDb8DoZidKptJNjvssfOY8vRWN4K9fdbFmE9RweP7Fg4xTlTfirVY-RFJBw6rbitkMha3h7-WPk9tH26vb9nrLUVGy3wSHY8e7io7k9R3_w3uo_22r92g-ZuJv72zN5uEz3rMnub9CcQA_",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-05-26T15:39:46.978219Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "account_id": null,
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2026-03-28T21:36:19+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.DAfxUTsijw_qLMveqoqq69_XgVEJpk2FNTPBkPc6-nl2tcbD-f153Rleri_E9rDYJyUJ3Kf23elLft-0TM2mw55bkw6jDX7283BeN9HjZHzvD_PqWgRsIiw5r1fuFg-LWDPl8wuWkRs5fHCVrtYtVzC4kbGuhay_Smc-IwJ6DUly3-RbObP0EYMJUD3NIbbaVM4vjvmvYH7GOYwDb8DoZidKptJNjvssfOY8vRWN4K9fdbFmE9RweP7Fg4xTlTfirVY-RFJBw6rbitkMha3h7-WPk9tH26vb9nrLUVGy3wSHY8e7io7k9R3_w3uo_22r92g-ZuJv72zN5uEz3rMnub9CcQA_'

// {
//   "access_token": "v2.local.liQbsAckCC6FFg-7l7oY7j9oVhVAoUOx8VXLdv7w___RsUNnvjwD7uNrCb1GSC-c6Q_56QC2VjzSGGZDovIyFiSEyqg_7FCnXotc80NOkE6KXOfu1R1Ii4J53bf6CaBCdFQflpQe5wR6_cVCFQedkgExjqCtpC_BsQ1GMD8TFNtSQPyzWFX_WPpKZF9-7hNlmnECg4ZwTxk0RqlMZFcjQuQnHHUH-V47gS5vPmlS8CiSpUdvsUavMIWAuu2TQb1cCAzB1VqfZm3HTJHHPjK2uo6uSNHztYDw8498_2sUXg0gEbFToU8AJT9RW_wHOecwg_vQZGGgEF1Y2BShybj9qrzEh_w",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2026-05-26T15:36:39.181043Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.liQbsAckCC6FFg-7l7oY7j9oVhVAoUOx8VXLdv7w___RsUNnvjwD7uNrCb1GSC-c6Q_56QC2VjzSGGZDovIyFiSEyqg_7FCnXotc80NOkE6KXOfu1R1Ii4J53bf6CaBCdFQflpQe5wR6_cVCFQedkgExjqCtpC_BsQ1GMD8TFNtSQPyzWFX_WPpKZF9-7hNlmnECg4ZwTxk0RqlMZFcjQuQnHHUH-V47gS5vPmlS8CiSpUdvsUavMIWAuu2TQb1cCAzB1VqfZm3HTJHHPjK2uo6uSNHztYDw8498_2sUXg0gEbFToU8AJT9RW_wHOecwg_vQZGGgEF1Y2BShybj9qrzEh_w'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
